const UploadThesis = {
  tableConfig: {
    comment: '说明：材料未上传齐全的学生无法送审。',
    showCheckbox: true,
    minWidth: 1250,
    checkboxFilter: '{state}==0 && {complete}==1' // 成立 显示 checkbox
  },
  queryList: [
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'complete',
      label: '当前状态',
      component: 'select',
      componentAttr: {
        options: [{
          value: 0,
          label: '材料上传'
        }, {
          value: 1,
          label: '上传完成'
        }
        ]
      }
    },
    {
      name: 'schoolNo',
      label: '学号',
      component: 'input'
    },
    {
      name: 'authorName',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'submitTimeRange',
      label: '提交时间',
      component: 'dateRange'
    },
    {
      name: 'auditExpertNum',
      label: '送审专家数',
      component: 'input',
      type: 'number'
    }
  ],
  urlMap: {
    'select': {
      url: '/paper/paperBaseInfo/queryPaperInfo',
      data: {
        state: 0
      }
    },
    'reviewSelect': '/paper/paperBaseInfo/updateStateIds',
    'reviewAll': '/paper/paperBaseInfo/sendAllPaper',
    'delete': '/paper/paperBaseInfo/delete'
  },
  operList: [// 操作列表
    {
      name: 'msgIsFull',
      label: '送审材料上传',
      show: true,
      action: {
        type: 'request',
        method: 'fetch',
        addr: '/sys/user/isFull',
        nextAction: 'upload',
        errorNextAction: 'showUserMsg'
      }
    },
    {
      name: 'upload',
      label: '送审材料上传',
      show: false,
      action: {
        type: 'dialog',
        width: 560,
        footerHide: true,
        addr: 'thesisManage/uploadThesis'
      }
    },
    {
      name: 'showUserMsg',
      label: '显示用户信息',
      show: false,
      action: {
        type: 'func',
        addr: 'showUserMsg'
      }
    },
    {
      name: 'chooseReview',
      label: '选中送审',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '("{tableSelectionIds}").split(",")',
        addr: 'reviewSelect'
      }
    },
    {
      name: 'allReview',
      label: '全部送审',
      show: true,
      action: {
        type: 'request',
        addr: 'reviewAll',
        data: '{searchParam}'
      }
    }
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'academyName',
      label: '所在学院'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'schoolNo',
      label: '学号',
      action: {
        title: '送审信息',
        type: 'dialog',
        addr: 'thesisManage/thesisEdit?{id}&readonly',
        width: 800
      }
    },
    {
      name: 'authorName',
      label: '姓名'
    },
    {
      name: 'hasPaper',
      label: '原文',
      type: 'checkbox'
    },
    {
      name: 'hasAbs',
      label: '摘要',
      type: 'checkbox'
    },
    {
      name: 'hasBi',
      label: '简况表',
      type: 'checkbox'
    },
    {
      filter: '',
      name: 'hasSr',
      label: '自评表',
      type: 'checkbox'
    },
    {
      name: 'auditExpertNum',
      label: '送审专家数',
      width: 106
    },
    {
      name: 'complete',
      label: '当前状态',
      map: {
        0: '材料未上传',
        1: '上传完成'
      }
    },
    {
      name: 'submitTime',
      label: '提交时间'
    },
    {
      name: 'operation',
      label: '操作',
      width: 120,
      actionList: [
        {
          label: '修改',
          name: 'update',
          kind: 'primary',
          type: 'dialog',
          width: 800,
          addr: 'thesisManage/thesisEdit?{id}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default UploadThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/allAuthorize/fuUploadThesis.js